import { useState, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
function createWrapper(wrapperId) {
    var wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    return wrapperElement;
}
function appendToBody(wrapperElement) {
    document.body.appendChild(wrapperElement);
}
function ReactPortal(param) {
    var children = param.children, _wrapperId = param.wrapperId, wrapperId = _wrapperId === void 0 ? "portal-wrapper" : _wrapperId, customCreateWrapper = param.customCreateWrapper, customAppendElement = param.customAppendElement;
    var ref = useState(null), wrapperElement = ref[0], setWrapperElement = ref[1];
    useLayoutEffect(function() {
        var element = document.getElementById(wrapperId);
        var systemCreated = false;
        // if element is not found with wrapperId or wrapperId is not provided,
        // creat e and append to body
        if (!element) {
            systemCreated = true;
            element = customCreateWrapper ? customCreateWrapper() : createWrapper(wrapperId);
            if (customAppendElement) {
                customAppendElement(element);
            } else {
                appendToBody(element);
            }
        }
        setWrapperElement(element);
        return function() {
            // delete the programatically created element
            if (systemCreated && (element === null || element === void 0 ? void 0 : element.parentNode)) {
                element.parentNode.removeChild(element);
            }
        };
    }, [
        wrapperId
    ]);
    // wrapp erElement state will be null on very first render.
    if (wrapperElement === null) return null;
    return /*#__PURE__*/ createPortal(children, wrapperElement);
}
export default ReactPortal;
